import { useFormikContext, FieldArray } from "formik"
import _ from "lodash"
import { trimTextValue } from "../../../components/FieldTypes/helpers/trimTextValue"
import SystemFieldWarning from "./SystemFieldWarning"

// Styles
import styles from "../../../styles/Form.module.css"

// Prime
import { InputText as Input } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import { classNames } from "primereact/utils"

export default function TypeSelectOptions({ rsi_required }) {
  const formik = useFormikContext()
  const { field_type, field_options } = formik.values

  const typeNumber = ["number"]
  const typeSelect = ["dropdown", "dropdowngrouped", "checkbox", "radio"]

  const isTypeSelect = typeSelect.includes(field_type)
  const isTypeNumber = typeNumber.includes(field_type)

  if (rsi_required && (isTypeNumber || isTypeSelect)) {
    const warnTypeText = isTypeNumber ? "min/max values" : "options"
    return (
      <SystemFieldWarning label="Options:" warnTypeText={warnTypeText} />
    )
  }

  switch (true) {
    case isTypeNumber:
      return (
        <>
          <div className={styles.field}>
            <label className={styles.label}>Min:</label>
            <InputNumber
              name="field_number_min"
              onChange={({ value }) => {
                const maxValue = formik.values.field_number_max
                const newValue = value === null ? 0 : value
                if (newValue > maxValue) {
                  formik.setFieldValue("field_number_max", newValue + 1)
                }
                formik.setFieldValue("field_number_min", newValue)
              }}
              onBlur={formik.handleBlur}
              value={formik.values.field_number_min}
              className={styles.value}
              disabled={rsi_required}
            />
            {formik.touched.field_number_min &&
              formik.errors.field_number_min && (
                <div className={styles.errFieldMsg}>
                  {formik.errors.field_number_min}
                </div>
              )}
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Max:</label>
            <InputNumber
              name="field_number_max"
              onChange={({ value }) => {
                formik.setFieldValue("field_number_max", value)
              }}
              onBlur={formik.handleBlur}
              value={formik.values.field_number_max}
              className={styles.value}
              disabled={rsi_required}
            />
            {formik.touched.field_number_max &&
              formik.errors.field_number_max && (
                <div className={styles.errFieldMsg}>
                  {formik.errors.field_number_max}
                </div>
              )}
          </div>
        </>
      )
    case isTypeSelect:
      return (
        <>
          {field_type === "dropdowngrouped" && (
            <small style={{ display: "block", marginBottom: 15 }}>
              Each option should be format as: "Parent | Value" for this type of
              Field.
            </small>
          )}
          <FieldArray
            name="field_options"
            render={(arrayHelpers) => (
              <div>
                {field_options && field_options.length > 0 ? (
                  _.map(field_options, (field, index) => {
                    return (
                      <div key={index} className={classNames(styles.field, styles.value)}>
                        <label className={styles.label}>Options:</label>
                        <Input
                          name={`field_options.${index}`}
                          value={field}
                          onChange={(e) => formik.handleChange(trimTextValue(e))}
                          onBlur={formik.handleBlur}
                          disabled={rsi_required}
                        />
                        <button
                          type="button"
                          onClick={() => arrayHelpers.remove(index)}
                          disabled={rsi_required}
                        >
                          <span className="material-icons">remove</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => arrayHelpers.insert(index + 1, "")}
                          disabled={rsi_required}
                        >
                          <span className="material-icons">add</span>
                        </button>
                      </div>
                    )
                  })
                ) : (
                  <button
                    type="button"
                    className="btn-sm"
                    style={{ margin: "5px 0 30px" }}
                    onClick={() => arrayHelpers.push("")}
                    disabled={rsi_required}
                  >
                    Add a Option
                  </button>
                )}
              </div>
            )}
          />
        </>
      )
    default:
      return null
  }
}
